module.exports = __webpack_public_path__ + "img/ellipsis-stroke-vertical.88d8c093.svg";